/**
 * DUX desktop rail collapse — this browser only (default expanded).
 * Shared by the app-bar toggle and DesktopShell. Phone Smarty never reads this.
 */
const KEY = 'ae.dux.sidebarCollapsed'

const listeners = []

export function readSidebarCollapsed () {
  try {
    return window.localStorage.getItem(KEY) === '1'
  } catch (e) {
    return false
  }
}

export function writeSidebarCollapsed (collapsed) {
  try {
    window.localStorage.setItem(KEY, collapsed ? '1' : '0')
  } catch (e) {
    /* private mode */
  }
}

export function getSidebarCollapsed () {
  return readSidebarCollapsed()
}

export function setSidebarCollapsed (collapsed) {
  const next = !!collapsed
  writeSidebarCollapsed(next)
  listeners.slice().forEach((fn) => {
    try {
      fn(next)
    } catch (e) {
      /* listener */
    }
  })
}

export function toggleSidebarCollapsed () {
  setSidebarCollapsed(!readSidebarCollapsed())
}

export function subscribeSidebarCollapsed (fn) {
  listeners.push(fn)
  return () => {
    const i = listeners.indexOf(fn)
    if (i >= 0) listeners.splice(i, 1)
  }
}
